// @ts-check
import uid from 'uid';
import { Rule, ConditionalGroup, Conditional } from './types'; // eslint-disable-line no-unused-vars

/**
 * @returns {Conditional}
 */
const newConditional = () => ({});

/**
 * @returns {ConditionalGroup}
 */
const newConditionalGroup = () => ({
  operator: 'AND',
  children: [],
  conditionals: [newConditional()],
});

/**
 * @returns {Rule}
 */
const newRule = () => ({
  id: uid('10'),
  persisted: false,
  rootConditionalGroupAttributes: newConditionalGroup(),
});

export { newConditional, newConditionalGroup, newRule };
